import React, { useState } from 'react'
import { Button, Dialog } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import BarrerasDeBruto from './BarrerasDeBruto'
import { COLORES } from '../../../../config/colores'

function ControlBarrerasBruto (props) {
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    props.dialogOpen(true)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    props.dialogOpen(false)
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='lg'>
        <DialogView
          cancelCallback={handleClose}
          title='Control de barreras'
          content={
            <BarrerasDeBruto
              setMotivoActividadBarrera={props.setMotivoActividadBarrera}
              forzarBarreras={props.forzarBarreras}
              updateForzado={props.updateForzado}
              modoBarreras={props.modoBarreras}
              updateCiclo={props.updateCicloBarreras}
              rolAutorizado={props.rolAutorizado}
              abrirBarreraEntradaBruto={props.abrirBarreraEntradaBruto}
              cerrarBarreraEntradaBruto={props.cerrarBarreraEntradaBruto}
              cerrarBarreraSalidaBruto={props.cerrarBarreraSalidaBruto}
            />
          }
        />
      </Dialog>
      <Button
        onClick={handleOpen}
        variant='contained'
        className='btn-bruto-action'
        style={{ backgroundColor: COLORES.grey.dark, color: '#ffffff', fontWeight: 'bold' }}
        size='small'
      >
                Control barreras
      </Button>
    </>
  )
}

export default ControlBarrerasBruto
